import "./receipt.css";

import { useHardcopyBorders } from "@/theme/useHardcopyBorders";

const DEFAULT_NOTES = [
  "Voluntary Contribution.",
  "This is a computer generated receipt and does not require a signature.",
];

/** `notes` replaces the default lines, for receipts where "voluntary contribution" would be wrong. */
const ReceiptFooter = ({ notes = DEFAULT_NOTES }: { notes?: readonly string[] }) => {
  const { solid5 } = useHardcopyBorders();
  return (
    <>
      <div
        className="u-col u-col-100"
        style={{
          padding: "5px 5px 5px",
          borderTop: solid5,
          boxSizing: "border-box",
        }}
      >
        <div>
          <span style={{ fontSize: "10px" }}>
            {notes.map((note) => (
              <li key={note}>{note}</li>
            ))}
          </span>
        </div>
      </div>
    </>
  );
};

export default ReceiptFooter;
